module.exports = __webpack_public_path__ + "static/media/tuatRed.256423ff.svg";